import React from "react";

const ComingSoon = () => {
  return (
    <div className="bg-white p-2  flex flex-col max-w-[281px] ">
      <p className="text-gray-800 text-sm  font-normal">
      Coming Soon
      </p>
    </div>
  );
};

export default ComingSoon;